export enum PickupTargetType {
    Employee = 1,
    Partner = 2
}
